import { render, staticRenderFns } from "./EditorElementInfoPropertiesAdd.vue?vue&type=template&id=de6e0bbc&lang=pug"
import script from "./EditorElementInfoPropertiesAdd.vue?vue&type=script&lang=js"
export * from "./EditorElementInfoPropertiesAdd.vue?vue&type=script&lang=js"
import style0 from "./EditorElementInfoPropertiesAdd.vue?vue&type=style&index=0&id=de6e0bbc&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports